import { inject, observer } from "mobx-react";
import React from "react";

export interface IScoreSubTitleProps {
    text?: string;
}

@inject()
@observer
export class ScoreSubTitle extends React.Component<IScoreSubTitleProps> {
    render() {
        const { text } = this.props;
        return <h6 className="subtitle">{text}</h6>;
    }
}
